module.exports = __webpack_public_path__ + "img/arrow-right.7c208c0c.svg";